export default __webpack_public_path__ + "static/media/text.44787e30.svg";